"use client";
import type { Locales } from "@/i18n/i18nConfig";
import { usePathname } from "next/navigation";
import GoogleTagManager from "./GoogleTagManager";
import Sourcepoint from "./Sourcepoint/Sourcepoint";
import SourcepointCookieWindow from "./Sourcepoint/SourcepointCookieWindow";
import TrackingConsentListener from "./Sourcepoint/TrackingConsentListener";
import { environment } from "@/utils/enviroment";

const GTMScript = ({ locale }: { locale: Locales }) => {
	const pathname = usePathname();

	// No CMP to load outside prod, but the listener still has an answer to give there — the
	// ?tracking=1 opt-in. It has to be read on page load: by the time anything tracks, the visitor
	// has navigated and the parameter is gone.
	if (environment.name !== "prod") {
		return <TrackingConsentListener />;
	}

	return (
		<>
			{pathname !== `/${locale}/app/update-available` && (
				<>
					<Sourcepoint />
					<GoogleTagManager gtmId="GTM-KV6HFP4W" />
					<SourcepointCookieWindow />
					<TrackingConsentListener />
				</>
			)}
		</>
	);
};

export default GTMScript;
